import { IInvoice } from "../../shared/interfaces/invoice/IInvoice";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { requests } from "../../utils/api/api.service";
import { INVOICE_URL } from "../../utils/api/endpoints";

export const AdminInvoiceService = {
  get: (pagination: IPagination): Promise<IBaseModel<IInvoice[]>> =>
    requests.get(INVOICE_URL, pagination),
  getSingle: (id: number): Promise<IInvoice> =>
    requests.get(`${INVOICE_URL}/${id}`),
  create: (params: IInvoice) => requests.post(INVOICE_URL, params),
  update: (params: IInvoice, id: number) =>
    requests.put(`${INVOICE_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${INVOICE_URL}/${id}`),
};
